<template lang="pug">
.form-residential-wrapper
  .form-residential-photo
      .form-residential-photo__label
          | Основное фото

      SvUpload.form-residential-photo__upload(
          v-model="original_image"
          :class="{ 'form-residential-photo__upload--no-image': !original_image }"
      )

      .form-residential-photo__label
          | Фото о проекте

      .form-residential-photo__field
          SvUpload.form-residential-photo__upload(
              v-model="preview_picture"
              :class="{ 'form-residential-photo__upload--no-image': !preview_picture }"
          )

          SvInput(
              v-if="preview_picture"
              v-model="preview_picture_title"
              :withIcon="false"
              placeholder="Title"
              :style="{ marginTop: '25px', width: '310px' }"
          )

          SvInput(
              v-if="preview_picture"
              v-model="preview_picture_alt"
              :withIcon="false"
              placeholder="Alt"
              :style="{ marginTop: '20px', width: '310px' }"
          )

      .form-residential-photo__label
          | Фотогаллерея

      .form-residential-photo__field
          Gallery

      .empty-line
</template>

<script>
import Gallery from '@/components/forms/subforms/Gallery.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'FormResidentialPhoto',

  computed: {
      ...mapGetters({
        current: 'residential/getCurrent',
      }),

    original_image: {
      get() {
        return this.current.original_image;
      },

      set(original_image) {
        this.setValue({ original_image });
      },
    },

    preview_picture: {
      get() {
        return this.current.preview_picture;
      },

      set(preview_picture) {
        this.setValue({ preview_picture });
      },
    },


    preview_picture_alt: {
      get() {
        return this.current.preview_picture_alt;
      },

      set(preview_picture_alt) {
        this.setValue({ preview_picture_alt });
      },
    },


    preview_picture_title: {
      get() {
        return this.current.preview_picture_title;
      },

      set(preview_picture_title) {
        this.setValue({ preview_picture_title });
      },
    },
  },

   methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),
  },

  components: {
    SvUpload,
    SvInput,
    Gallery,
  },
};
</script>

<style lang="scss" scoped>

.empty-line {
  height: 20px;
}
.form-residential-wrapper {
  min-height: calc(100vh - 263px);
}

.form-residential-photo {
    display: grid;
    grid-template-columns: 140px 1fr;
    grid-gap: 25px 50px;
    padding-top: 50px;
    padding-left: 25px;

    &__label {
        justify-self: flex-end;
        margin-top: 12px;
    }

    &__upload {
        max-width: 310px;

        &--no-image {
            width: 140px;
        }
    }
}
</style>
